module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_desktop_01.41381236.svg";